import { connect } from 'react-redux'

import AuthenticationProcessComponent from './AuthenticationProcess'
import { postAnalyticsEvent } from '@/store/actions/event'
import { getAccountInfo, storeIsUserAuthenticated, storeUserName } from '@/store/reducers/user'
import {
  selectIsAuthenticated,
  selectUsersUsername,
  selectUsersVisitorKey,
} from '@/store/selectors/user'

const MapStateToProps = state => ({
  visitorKey: selectUsersVisitorKey(state),
  username: selectUsersUsername(state),
  isAuthenticated: selectIsAuthenticated(state),
})

const MapDispatchToProps = dispatch => ({
  storeIsUserAuthenticated: isAuthenticated => dispatch(storeIsUserAuthenticated(isAuthenticated)),
  storeUserName: name => dispatch(storeUserName(name)),
  getAccountInfo: () => dispatch(getAccountInfo()),
  postAnalyticsEvent: data => dispatch(postAnalyticsEvent(data)),
})

const AuthenticationProcess = connect(
  MapStateToProps,
  MapDispatchToProps,
)(AuthenticationProcessComponent)

export default AuthenticationProcess
